import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { TextFormat } from '@ee/common/enums';

const URL_PATTERN = /^https?:\/\/\S+$/;

function url(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (value === null || value === undefined || value === '') return null;
  return URL_PATTERN.test(String(value).trim()) ? null : { url: true };
}

/** The validators a TEXT field's `format` adds. Blank is never a format error — required is separate. */
export function formatValidators(format: TextFormat | null | undefined): ValidatorFn[] {
  switch (format) {
    case TextFormat.EMAIL:
      return [Validators.email];
    case TextFormat.URL:
      return [url];
    default:
      return [];
  }
}
